export default __webpack_public_path__ + "static/media/u27634.a5f4034c.svg";